import { memo } from "react";

/**
 * On/off cell built on a real checkbox, so it is reachable by keyboard and
 * announced correctly; the track and knob are styling over that input.
 *
 * @param {object} props
 * @param {boolean} props.checked
 * @param {boolean} [props.dirty]
 * @param {boolean} [props.disabled]
 * @param {string} props.ariaLabel
 * @param {(checked: boolean) => void} props.onChange
 */
function SwitchCell({ checked, dirty, disabled, ariaLabel, onChange }) {
  return (
    <label className={`kgb-switch${dirty ? " kgb-switch--dirty" : ""}`}>
      <input
        type="checkbox"
        checked={!!checked}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="kgb-switch-track" />
    </label>
  );
}

export default memo(SwitchCell);
